import app from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const config = {
  apiKey: "AIzaSyDoVUMvoYSDYtsbIWSWwMQw-fLiARXq6Jo",
  authDomain: "cool-project-57508.firebaseapp.com",
  databaseURL: "https://cool-project-57508.firebaseio.com",
  projectId: "cool-project-57508",
  storageBucket: "cool-project-57508.appspot.com",
  messagingSenderId: "322740544176",
  appId: "1:322740544176:web:4e350089c87e259bd31175",
};

class Firebase {
  auth: app.auth.Auth;
  db: app.firestore.Firestore;
  storage: app.storage.Storage;

  constructor() {
    app.initializeApp(config);
    this.auth = app.auth();
    this.db = app.firestore();
    this.storage = app.storage();
  }

  // *** Auth API ***

  doCreateUserWithEmailAndPassword = (email: string, password: string) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email: string, password: string) =>
    this.auth.signInWithEmailAndPassword(email, password);

  // doSignOut = () => this.auth.signOut();

  // doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  // doPasswordUpdate = password =>
  //   this.auth.currentUser.updatePassword(password);

  // *** Product API ***

  products = () => this.db.collection("products");

  categories = () => this.db.collection("categories");

  orders = () => this.db.collection("order");

  orderedProducts = () => this.db.collection("ordered_products");

  authentication = () => this.auth;

  accessImage = (name: string) =>
    this.storage.ref().child(`/assets/${name}`).getDownloadURL();
}

export default Firebase;
